import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ContractTerminationReasonService } from 'src/app/shared/store/contract-termination-reason/contract-termination-reason.service';
import { ContractTerminationReasonModel } from 'src/app/shared/store/contract-termination-reason/types';
import { SubHeaderService } from 'src/app/shared/store/subheader/subheader.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BreadcrumbService } from 'xng-breadcrumb';
import { filter } from 'rxjs/operators';
import { View } from '../../../../shared/store/view/types';
import { ViewService } from '../../../../shared/store/view/views.service';

@UntilDestroy()
@Component({
  selector: 'app-contract-termination-reason-details',
  templateUrl: './contract-termination-reason-details.component.html',
  styleUrls: ['./contract-termination-reason-details.component.scss'],
  standalone: false,
})
export class ContractTerminationReasonDetailsComponent
  implements OnInit, OnDestroy
{
  contractTerminationReasonId: number;
  contractTerminationReasonModel$: Observable<ContractTerminationReasonModel>;
  view$: Observable<View>;

  @Input() modalId: number;

  constructor(
    private route: ActivatedRoute,
    private readonly router: Router,
    private readonly contractTerminationReasonService: ContractTerminationReasonService,
    private readonly subHeaderService: SubHeaderService,
    private readonly breadcrumbService: BreadcrumbService,
    private readonly viewService: ViewService,
  ) {
    this.contractTerminationReasonModel$ =
      this.contractTerminationReasonService.getById.value$;
    this.view$ = this.viewService.getViews.value$;
  }

  ngOnInit(): void {
    this.contractTerminationReasonId = this.route.snapshot.params['id'];

    if (this.modalId) this.contractTerminationReasonId = this.modalId;

    this.contractTerminationReasonService.getById.call(
      this.contractTerminationReasonId.toString(),
    );

    this.contractTerminationReasonModel$
      .pipe(
        untilDestroyed(this),
        filter((x) => !!x),
      )
      .subscribe((x) => {
        this.breadcrumbService.set('@contractTerminationReasonDetails', x.name);
      });
    this.view$
      .pipe(
        untilDestroyed(this),
        filter((x) => !!x),
      )
      .subscribe((x) => {
        this.breadcrumbService.set('@list', x.title);
      });

    this.subHeaderService
      .getTriggerAction()
      .pipe(untilDestroyed(this))
      .subscribe((x) => {
        if (x == 'contractTerminationReasonEdit') {
          this.router.navigate([
            'Insurance/ContractTerminationReasons/Edit/',
            this.contractTerminationReasonId,
          ]);
        }
        this.subHeaderService.setTriggerAction('');
      });
  }

  ngOnDestroy(): void {
    this.contractTerminationReasonService.getById.reset();
    this.breadcrumbService.set('@contractTerminationReasonDetails', ' ');
  }
}
